import React from 'react';
import person1 from '@/assets/login/person_1.jpg';
import person2 from '@/assets/login/person_2.jpg';
import person3 from '@/assets/login/person_3.jpg';
import person4 from '@/assets/login/person_4.jpg';
import person5 from '@/assets/login/person_5.jpg';

const ScrollingPeople: React.FC = () => {
    const peopleImages = [person1, person2, person3, person4, person5];

    return (
        <div className="h-full w-full overflow-hidden flex gap-4 pr-4">
            {/* First column - normal scroll */}
            <div className="flex-1 h-full overflow-hidden">
                <div className="animate-scroll">
                    {peopleImages.map((image, index) => (
                        <img
                            key={`col1-${index}`}
                            src={image}
                            alt={`Person ${index + 1}`}
                            className="w-full block mb-4"
                        />
                    ))}
                    {/* Repeat for continuous scroll */}
                    {peopleImages.map((image, index) => (
                        <img
                            key={`col1-repeat-${index}`}
                            src={image}
                            alt={`Person ${index + 1}`}
                            className="w-full block mb-4"
                        />
                    ))}
                </div>
            </div>

            {/* Second column - offset scroll (same images, different timing) */}
            <div className="flex-1 h-full overflow-hidden">
                <div className="animate-scroll" style={{animationDelay: '-60s'}}>
                    {peopleImages.map((image, index) => (
                        <img
                            key={`col2-${index}`}
                            src={image}
                            alt={`Person ${index + 1}`}
                            className="w-full block mb-4"
                        />
                    ))}
                    {/* Repeat for continuous scroll */}
                    {peopleImages.map((image, index) => (
                        <img
                            key={`col2-repeat-${index}`}
                            src={image}
                            alt={`Person ${index + 1}`}
                            className="w-full block mb-4"
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ScrollingPeople;
